const DescriptionSection = ({ description }) => {
    return (
        <div className="mb-8">
            <div
                dangerouslySetInnerHTML={{
                    __html: description,
                }}
            />
        </div>
    )
}

export default DescriptionSection
